"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../../../../style/variables");
var styles = {
    container: react_1.css({
        background: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
        padding: 16,
        borderRadius: 6,
    }),
};
var ChartTooltipContainer = function (props) { return (react_1.jsx("div", __assign({ css: styles.container }, props))); };
exports.default = ChartTooltipContainer;
